import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';
import { GET_PLACES } from '../../../common/graphql/place';


const PlaceSelector = (props) => {
	const { query } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_PLACES}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select place"
			{...props}
		/>
	);
};
export default PlaceSelector;

